import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Router} from '@angular/router';
import {AuthService} from './auth.service';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {ShoppingService} from '../../component/services/shopping.service';

@Injectable()
export class UserService {

  private _loggedIn = new BehaviorSubject<Boolean>(false);
  public get loggedIn(): BehaviorSubject<Boolean> {
    return this._loggedIn;
  }

  private _user = new BehaviorSubject(null);
  public get user(): BehaviorSubject<any> {
    return this._user;
  }

  constructor(private localStorageService: LocalStorageService,
    private router: Router,
    private authService: AuthService,
    private shoppingService: ShoppingService,
    private httpClient: HttpClient) {
    if (this.authService.isAuthenticated()) {
      if (this.authService.user) {
        this._user.next(this.authService.user);
        setTimeout(() => this._loggedIn.next(true));
      } else {
        this.logout(true);
      }
    }
  }

  public logout(force = false) {
    if (this._loggedIn.getValue() || force) {
      this.shoppingService.clear();
      this.router.navigate(['auth/logout']);
    }
  }

  public test(event: any) {
    return this.httpClient.put(`${environment.auth_api}users/grosssetting`, {grossSetting: event.checked},
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})}).subscribe();
  }

  public getCompanyInfo() {
    return this.httpClient.get(`${environment.resource_api}companies/${this.user.getValue().companies[0].company.id}/info`,
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }

  public addCompanyAddress(form: {address: string, postalCode: string, city: string}) {
    return this.httpClient.post(`${environment.resource_api}companies/${this.user.getValue().companies[0].company.id}/address`,
      form,
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }

  public getCompany() {
    return this.user.getValue().companies[0].company;
  }

  public getMe(getCompany: boolean, getOrders: boolean, settings?: boolean) {
    return this.httpClient.get(`${environment.auth_api}users/me?company=${getCompany}&orders=${getOrders}&settings=${settings}`,
        {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }
}
